import { render, staticRenderFns } from "./twitter_instantwin_message.vue?vue&type=template&id=539872c0"
import script from "./twitter_instantwin_message.vue?vue&type=script&lang=ts"
export * from "./twitter_instantwin_message.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports